import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseHttpService } from './base-http.service';
import { Observable } from 'rxjs/Observable';
import { Building, BuildingLevel, CompanyBuildingUnitView, BuildingUnit } from '../models';

@Injectable()

export class BuildingService extends BaseHttpService<any> {
  constructor(private http: HttpClient) {
    super();
  }

  getBuildings(): Observable<Building[]> {

    return this.http
      .get(this.getApiURI() + "/buildings/GetBuildings")
      .catch(this.handleError)
  }

  getBuildingLevels(): Observable<BuildingLevel[]> {
    return this.http
      .get(this.getApiURI() + "/buildings/GetBuildingLevels")
      .catch(this.handleError)
  }

  getBuildingUnits(id: number, filterUnits: boolean): Observable<CompanyBuildingUnitView[]> {
    return this.http
      .get(this.getApiURI() + `/tenants/${id}/GetBuildingUnitsForCompany/${filterUnits}`)
      .catch(this.handleError)
  }

  getAllBuildingUnits(): Observable<BuildingUnit[]> {
    return this.http
      .get(this.getApiURI() + "/buildings/GetBuildingUnits")
      .catch(this.handleError)
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/building.service.ts